// extracted by mini-css-extract-plugin
export var card = "_mr-0";
export var content = "_mr-2";
export var details = "_mr-3";
export var icon = "_mr-1";
export var iconBlue = "_mr-5";
export var iconBrand = "_mr-4";
export var iconGrayBlue = "_mr-6";
export var iconGreen = "_mr-7";
export var iconIndigo = "_mr-8";
export var iconOrange = "_mr-9";
export var iconPurple = "_mr-a";
export var iconRed = "_mr-b";
export var iconWarning = "_mr-c";